import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import {
  LoanCalculatorActions,
  LoanCalculatorSequenceServerData,
  LoanCalculatorLookupsServerData,
  AutoLoanAttributes,
} from './loanCalculator.types'

export class LoanCalculatorProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/loan_calculator_api.php`
  }

  public sequence(): Promise<HttpServiceResponse<LoanCalculatorSequenceServerData>> {
    return this.http.post(`${this.url}?action=${LoanCalculatorActions.Seq}`)
  }

  public lookups(): Promise<HttpServiceResponse<LoanCalculatorLookupsServerData>> {
    return this.http.post(`${this.url}?action=${LoanCalculatorActions.Lookups}`)
  }

  public auto(attributes: AutoLoanAttributes): Promise<HttpServiceResponse<any>> {
    const queryString = qs.stringify({
      action: LoanCalculatorActions.Auto,
      ...attributes,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }

  public clear(attributes: any): Promise<HttpServiceResponse<any>> {
    const queryString = qs.stringify({
      action: LoanCalculatorActions.Clear,
      ...attributes,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }

  public add(attributes: any): Promise<HttpServiceResponse<any>> {
    const queryString = qs.stringify({
      action: LoanCalculatorActions.Add,
      ...attributes,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }

  public delete(attributes: any): Promise<HttpServiceResponse<any>> {
    const queryString = qs.stringify({
      action: LoanCalculatorActions.Delete,
      ...attributes,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }

  public print(attributes: any): Promise<HttpServiceResponse<any>> {
    const queryString = qs.stringify({
      ...attributes,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }
}
